import { elevateSession } from "@/api/stepUp";
import { useMutation } from "@tanstack/react-query";

export const useElevateSession = () => {
  return useMutation({
    mutationFn: elevateSession,
  });
};
